import {Dispatch, MutableRefObject, SetStateAction, useRef, useState} from 'react';

export default function useRefState<T>(initiaLValue: T): [MutableRefObject<T>, Dispatch<SetStateAction<T>>, T] {
    const [value, setValue] = useState<T>(initiaLValue);
    const ref = useRef<T>(initiaLValue);
    ref.current = value;
    return [ref, setValue, value];
}
